'use client';

import React from 'react';
import NextLink from 'next/link';
import classNames from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Types
import { BreadcrumbProps } from '../../types/navigation/breadcrumbs';

// Services
import { validate } from '../../services/navigation/breadcrumbs';

// Components
import { Icon } from '../Display/Icon';
import { Typography } from '../Typography/Typography';

export const Breadcrumbs = ({ type, options, label }: BreadcrumbProps) => (
  <nav className="breadcrumbs" aria-label={label} data-type={type}>
    <ol className="breadcrumbs__list">
      {options.map((option) => {
        validate(option);

        return (
          <li key={option.id}>
            {option.type === 'link' && (
              <NextLink
                rel={option.rel}
                target={option.target}
                href={option.to ?? '#'}
              >
                <BreadcrumbContent
                  text={option.text}
                  icon={option.icon}
                  hideText={option.hideText}
                />
              </NextLink>
            )}

            {option.type === 'no-link' && (
              <BreadcrumbContent
                text={option.text}
                icon={option.icon}
                hideText={option.hideText}
              />
            )}

            {option.type === 'click-event' && (
              <a role="button" href="#" onClick={option.onClick}>
                <BreadcrumbContent
                  text={option.text}
                  icon={option.icon}
                  hideText={option.hideText}
                />
              </a>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

type BreadcrumbContentProps = {
  text: string;
  hideText: boolean | undefined;
  icon: IconDefinition | undefined;
};

const BreadcrumbContent = ({
  text,
  icon,
  hideText,
}: BreadcrumbContentProps) => {
  const Component = icon ? 'div' : 'span';

  return (
    <Component className={classNames({ cluster: !hideText })}>
      {icon && <Icon icon={icon} title={text} addIcon />}

      <Typography component="span" addSrOnly={hideText}>
        {text}
      </Typography>
    </Component>
  );
};
